import { render, staticRenderFns } from "./travelRegistration.vue?vue&type=template&id=830fecfe&scoped=true"
import script from "./travelRegistration.vue?vue&type=script&lang=js"
export * from "./travelRegistration.vue?vue&type=script&lang=js"
import style0 from "./travelRegistration.vue?vue&type=style&index=0&id=830fecfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830fecfe",
  null
  
)

export default component.exports